import { useOnboardingStore } from '../stores/onboardingStore'

export default function WelcomeCard({ onBegin }) {
  const personalization = useOnboardingStore((s) => s.personalization)
  const liteMode = useOnboardingStore((s) => s.liteMode)

  const handleClick = (e) => {
    e.stopPropagation()
    onBegin?.()
  }

  // Lite mode (Docther / Kashif Friday flow) — own welcome branch above the
  // tier logic. Greets by practice name, calm subline, quiet trust strip.
  if (liteMode) {
    const litePracticeName = personalization?.practiceName?.trim() || ''

    return (
      <section
        className="welcome-v2 is-lite"
        aria-label="Welcome"
      >
        <div className="welcome-v2-eyebrow arrival arrival-eyebrow">
          Practice Onboarding
        </div>

        <h1 className="welcome-v2-heading arrival arrival-heading">
          {litePracticeName ? (
            <>
              Welcome,{' '}
              <span className="welcome-v2-name">{litePracticeName}</span>.
            </>
          ) : (
            <>Welcome.</>
          )}
        </h1>

        <p className="welcome-v2-subline arrival arrival-subtitle">
          Setup is on us. Fill this out and our team will reach out shortly.
        </p>

        <button
          type="button"
          className="welcome-v2-cta arrival arrival-button"
          onClick={handleClick}
        >
          Begin Setup <span aria-hidden="true">→</span>
        </button>

        <p className="welcome-v2-helper arrival arrival-helper">
          Or press <span aria-hidden="true">↵</span> to continue
        </p>

        <p className="welcome-v2-resume arrival arrival-resume">
          Saved. Return anytime.
        </p>

        <div
          className="welcome-v2-lite-strip arrival arrival-strip"
          aria-hidden="true"
        >
          <span className="welcome-v2-lite-strip-item">
            Network+ Setup Waived
          </span>
          <span className="welcome-v2-lite-strip-sep">·</span>
          <span className="welcome-v2-lite-strip-item">~10 minutes</span>
          <span className="welcome-v2-lite-strip-sep">·</span>
          <span className="welcome-v2-lite-strip-item">
            Team reaches out within 24hr
          </span>
        </div>
      </section>
    )
  }

  // Empty name must NEVER fabricate a person — fall back to '' so isPersonalized
  // is false and the heading shows the clean "Welcome to BRITE" branch.
  const ownerFirstName = personalization?.ownerFirstName?.trim() || ''
  const practiceName = personalization?.practiceName?.trim() || ''
  const welcomeLine = personalization?.welcomeLine?.trim() || ''
  const note = personalization?.note?.trim() || "Looking forward to a great partnership. When you're ready, click the link below to get started — takes about 10 minutes and you can save your progress anytime."
  const isPersonalized = !!ownerFirstName
  const hasNote = !!note
  const hasInlineLine = !note && !!welcomeLine

  // Determine which subline to render under the heading.
  // TIER 1 (no name): generic value prop with time estimate
  // TIER 2 (name only): friendly continuation
  // TIER 3 (name + practice): practice-specific
  let subline = null
  if (!isPersonalized) {
    subline = "Let's set up your practice. About 10 minutes."
  } else if (practiceName) {
    subline = `Let's set up ${practiceName}.`
  } else {
    subline = "Let's get your practice set up."
  }

  return (
    <section
      className={`welcome-v2${isPersonalized ? ' is-personalized' : ''}${hasNote ? ' has-note' : ''}`}
      aria-label="Welcome"
    >
      <h1 className="welcome-v2-heading arrival arrival-heading">
        {isPersonalized ? (
          <>
            Welcome,{' '}
            <span className="welcome-v2-name">{ownerFirstName}</span>.
          </>
        ) : (
          <>Welcome to BRITE</>
        )}
      </h1>

      <p className="welcome-v2-subline arrival arrival-subtitle">{subline}</p>

      {hasNote && (
        <blockquote className="welcome-v2-quote arrival arrival-note">
          <p className="welcome-v2-quote-text">"{note}"</p>
          <cite className="welcome-v2-quote-sig">— Josh, BRITE</cite>
        </blockquote>
      )}

      <button
        type="button"
        className="welcome-v2-cta arrival arrival-button"
        onClick={handleClick}
      >
        Begin Setup <span aria-hidden="true">→</span>
      </button>

      <p className="welcome-v2-helper arrival arrival-helper">
        Or press <span aria-hidden="true">↵</span> to continue
      </p>
    </section>
  )
}
